import { format, isValid } from "date-fns";
import { Clock } from "lucide-react";

import style from "./HeldDraftNotice.module.css";

const HOLD_REASON_TEXT = {
  MID_MONTH_REGISTRATION:
    "the patient was registered on PCRS in the first half of the month",
  PANEL_TRANSFER:
    "PCRS still shows this patient with a different GP, or not yet on your panel",
  BOTH: "the patient was registered mid-month and PCRS still shows a different GP",
};

const formatHoldUntil = (holdUntil) => {
  if (!holdUntil) return null;

  const date = new Date(holdUntil);

  return isValid(date) ? format(date, "d MMMM yyyy") : null;
};

// KIN-1236: the review was saved but the BE is holding it as a draft (not sent to
// HealthLink) until PCRS can verify the GP panel on the 1st. Shown on the CDM tab
// while a held draft exists for the patient; the release is attempted
// automatically once the hold date passes (see useHeldDraftRelease).
export const HeldDraftNotice = ({ holdUntil, holdReason }) => {
  const releaseDate = formatHoldUntil(holdUntil);
  const reason = HOLD_REASON_TEXT[holdReason];
  const isDue = !!holdUntil && new Date(holdUntil) <= new Date();

  return (
    <div className={style.notice} role="status">
      <Clock size={20} className={style.icon} />
      <p className={style.text}>
        {isDue
          ? `This review is saved as a draft and is awaiting PCRS panel verification${
              reason ? ` — ${reason}` : ""
            }. It will be submitted automatically as soon as PCRS confirms the panel; if it still can't be verified it stays held.`
          : `This review is saved as a draft and won't be sent to HealthLink yet${
              reason ? ` — ${reason}` : ""
            }. It will be submitted automatically${
              releaseDate ? ` on ${releaseDate}` : " on the 1st of next month"
            }, once PCRS can verify the GP panel.`}
      </p>
    </div>
  );
};
